/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shopping_TotalInputs */

const en_shopping_total = /** @type {(inputs: Shopping_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Est. total`)
};

const de_shopping_total = /** @type {(inputs: Shopping_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschätzt`)
};

/**
* | output |
* | --- |
* | "Est. total" |
*
* @param {Shopping_TotalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_total = /** @type {((inputs?: Shopping_TotalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_TotalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_total(inputs)
	return en_shopping_total(inputs)
});